// extracted by mini-css-extract-plugin
export default {"container":"VP-z","modal":"WP-z","dimensions":"XP-z","brandName":"YP-z","productName":"ZP-z","recipientEmail":"_P-z","recommendedFit":"aQ-z","hiddenField":"bQ-z"};